module.exports = __webpack_public_path__ + "static/media/kf2-logo.f742a25c.png";